export const cartHasPhysicalItems = cartItems => {
  return Array.isArray(cartItems) && cartItems.some(cartItem => cartItem.shippable_type !== 'Digital Delivery')
}

export const isCheckoutTotalsReady = ({ checkout, cartItems }) => {
  if (!checkout?.subtotalCalculated) return false
  if (checkout.subtotalLoading || checkout.checkoutLoading || checkout.taxLoading || checkout.shippingLoading)
    return false

  const checkoutData = checkout.checkoutData || {}
  if (!checkoutData.subtotal || !checkoutData.youPay) return false

  if (cartHasPhysicalItems(cartItems) && !checkoutData.tax) return false

  return true
}

export const isPunchoutCartPricingReady = ({ checkout }) => {
  if (!checkout?.subtotalCalculated) return false
  if (checkout.subtotalLoading || checkout.checkoutLoading) return false

  const checkoutData = checkout.checkoutData || {}
  if (!checkoutData.subtotal || !checkoutData.youPay) return false

  return true
}
